export default __webpack_public_path__ + "static/media/Bootstrap.c39bcc6e.png";